/**
 * @function genErrorInfo
 * @function validate
 * @class ItemListValue
 */
export const FormHelper = {
    genErrorInfo: function (formCount) {
        var errorInfo = [];
        for (var i = 0; i < formCount; i++) {
            let info = new ErrorInfo();
            errorInfo.push(info);
            // errorInfo.push({
            //     isValid: true,
            //     msg: '',
            // });
        }
        return errorInfo;
    },
    /**
     *
     * @param {Array} errorInfo
     * @param {boolean=} returnObj
     * @returns {(boolean|object)}  return boolean or object
     */
    validate: function (errorInfo, returnObj = false) {
        let ret = true
        for (var i of errorInfo) {
            if (!i.isValid) {
                ret =  returnObj ? i : false;

                break
            }
        }
        return ret;
    },
    /**
     *
     * @param {Array} errorInfo
     */
    filterError: function (errorInfo) {
        let findErr = errorInfo.filter(x => !x.isValid)
        return findErr
    }
};

export function ErrorInfo() {
    this.isValid = true;
    this.msg = '';

    this.setValid = function (valid) {
        this.isValid = valid;
    };

    this.setMsg = function (msg) {
        this.msg = msg
    };
}


export function DropdownListValue() {
    this.list = [];

    /**
     * @param {String} text
     * @param {String} value
     */
    this.add = function (text, value) {
        this.list.push({
            text: text,
            value: value,
        });
    };

    this.getList = function () {
        return this.list;
    };
}

export function GetTelephoneCountryCode() {
    let listCountryCode = new DropdownListValue()

    listCountryCode.add("+86", "86") //China
    listCountryCode.add("+852", "852") //Hongkong
    listCountryCode.add("+81", "81") //Japan
    listCountryCode.add("+66", "66") //Thailand
    listCountryCode.add("+82", "82") //Korea
    listCountryCode.add("+886", "886") //Taiwan
    listCountryCode.add("+65", "65") //Singapore

    return listCountryCode
}
